import getSymbolFromCurrency from "currency-symbol-map";
import { useState } from "react";
import DialogModal from "src/components/Dialog";
import { formatMoney } from "src/helper/functions";
import { AseobiAttire } from "src/utils/gql_types";
import { Pencil, Trash } from "../Icons";
import DeleteAttire from "../modals/DeleteAttire";
import EditAttire from "../modals/EditAttire";

interface Props {
  attire: AseobiAttire;
}

const Attire = ({ attire }: Props) => {
  const [open, setOpen] = useState(false);
  const [editAttireOpen, setEditAttireOpen] = useState(false);

  return (
    <div className="flex items-center gap-4 rounded-xl border p-4 shadow-lg">
      <div className="h-20 w-20 rounded-md border shadow-sm">
        {attire.images && (
          <img
            src={attire.images[0]}
            alt=""
            className="h-full w-full rounded-md object-cover"
          />
        )}
      </div>
      <div className="flex flex-grow flex-col gap-2 md:flex-row md:justify-between">
        <div className="flex flex-col gap-2">
          <p className="font-semibold">{attire.name}</p>
          <p className="text-sm text-gray-500">
            {getSymbolFromCurrency(attire.currency_iso)}
            {formatMoney(attire.price_per_yard)}
            /yard
          </p>
        </div>
        <div className={`flex items-center gap-2`}>
          <button className="flex size-8 items-center justify-center border hover:bg-gray-200">
            <DialogModal
              open={editAttireOpen}
              onOpenChange={setEditAttireOpen}
              trigger={
                <button className="flex size-8 items-center justify-center border hover:bg-gray-200">
                  <Pencil />
                </button>
              }
            >
              <EditAttire setOpen={setEditAttireOpen} attire={attire} />
            </DialogModal>
          </button>
          <DialogModal
            open={open}
            onOpenChange={setOpen}
            trigger={
              <button className="flex size-8 items-center justify-center border hover:bg-gray-200">
                <Trash />
              </button>
            }
          >
            <DeleteAttire setOpen={setOpen} attire={attire} />
          </DialogModal>
        </div>
      </div>
    </div>
  );
};

export default Attire;
